import { useState, useEffect, useRef, useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  getAllCategories,
  getCategorySubcategories,
} from '../../../services/product-api';

export const useProductCategoriesShortcut = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [category, setCategory] = useState('');
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const path = window.location.pathname;
    const segments = path.split('/').filter(Boolean);
    setCategory(segments[0]);
  }, []);

  const { data: categoryData, isLoading: isLoadingSubcategories } = useQuery({
    queryKey: ['subcategories', category],
    queryFn: () => getCategorySubcategories(category),
    enabled: !!category,
    retry: false,
  });

  const { data: categoriesData } = useQuery({
    queryKey: ['categories'],
    queryFn: getAllCategories,
  });

  const subcategories = categoryData?.data?.subcategories || [];
  const categories = Array.isArray(categoriesData?.data?.categories)
    ? categoriesData.data.categories
    : [];

  const toggleDropdown = useCallback(() => {
    setIsDropdownOpen((prev) => {
      if (prev) setSelectedDepartment(null);
      return !prev;
    });
  }, []);

  const closeDropdown = useCallback(() => {
    setIsDropdownOpen(false);
    setSelectedDepartment(null);
  }, []);

  const handleDepartmentClick = useCallback((department) => {
    setSelectedDepartment(department);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(e.target)
      ) {
        closeDropdown();
      }
    };

    document.body.style.overflow = isDropdownOpen ? 'hidden' : 'auto';

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'auto';
    };
  }, [isDropdownOpen, closeDropdown]);

  const getOverlayStyle = useCallback(() => {
    if (!buttonRef.current || !isDropdownOpen) return {};

    return {
      top: `${buttonRef.current.getBoundingClientRect().bottom}px`,
      left: 0,
      right: 0,
      bottom: 0,
      position: 'sticky',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 20,
    };
  }, [isDropdownOpen]);

  return {
    dropdownRef,
    buttonRef,

    category,
    subcategories,
    categories,
    isLoadingSubcategories,
    isDropdownOpen,
    selectedDepartment,

    toggleDropdown,
    closeDropdown,
    setIsDropdownOpen,
    handleDepartmentClick,
    getOverlayStyle,
  };
};
